/** capital_provider_profiles.capital_types vocabulary, shared by the page and the extension. */
export const CAPITAL_TYPES = [
  "Senior Debt", "Mezzanine", "Unitranche", "ABL", "SBA",
  "Equity Co-Invest", "Preferred Equity", "Seller Note",
  "Insurance", "BDC", "Other",
] as const;
